// import { useParams } from "react-router-dom";

export default function ConsumableSummary() {
  return <div>consumable-summary</div>;
}
